import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatPrice(price) {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(price);
}

/**
 * Get full URL for uploaded images
 * @param {string} url - The image URL (can be relative like /uploads/xxx.png or full URL)
 * @returns {string} Full URL to the image
 */
export function getImageUrl(url) {
  if (!url) return '';
  
  // If already a full URL, return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If relative URL starting with /api/uploads or /uploads, prepend dynamic backend URL
  if (url.startsWith('/api/uploads') || url.startsWith('/uploads')) {
    // Use dynamic URL based on current origin (works in production without rebuild)
    const backendUrl = window.location.origin;
    // Ensure URL has /api prefix
    const normalizedUrl = url.startsWith('/api/') ? url : `/api${url}`;
    return `${backendUrl}${normalizedUrl}`;
  }
  
  // Otherwise return as-is
  return url;
}
